export enum LanguageEnum {
    ITALIANO = 'it-IT',
    ENGLISH = 'en-GB',
    ESPANOL = 'es-ES',
    GERMAN = 'de-DE'
}